// Hash mode container component - Sign Image tab
// Frontend developers can modify the visual layout here

import type { UseHashModeReturn } from "../hooks/useHashMode";
import type { UseSigningFlowReturn } from "../hooks/useSigningFlow";
import { DropZone } from "./DropZone";
import { HashDisplay } from "./HashDisplay";
import { SigningSection } from "./SigningSection";

interface HashModeProps {
  hashMode: UseHashModeReturn;
  signingFlow: UseSigningFlowReturn;
}

export function HashMode({ hashMode, signingFlow }: HashModeProps) {
  const {
    preview,
    hashes,
    loading,
    loadingStatus,
    error,
    handleFileSelect,
    handleDrop,
    handleHashImage,
    fileInputRef,
    image,
  } = hashMode;

  return (
    <>
      {/* Drop Zone */}
      <DropZone
        preview={preview}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
        inputRef={fileInputRef}
        onFileSelect={handleFileSelect}
        mode="hash"
      />

      {/* Generate Hash Button */}
      <button
        className="hash-button"
        onClick={handleHashImage}
        disabled={!image || loading}
      >
        {loading ? "Processing..." : "Generate Hash"}
      </button>

      {/* Loading Status */}
      {loading && loadingStatus && (
        <div className="progress-status">
          <div className="progress-spinner"></div>
          <span>{loadingStatus}</span>
        </div>
      )}

      {/* Error Display */}
      {error && <div className="error">{error}</div>}

      {/* Hash Results & Signing Section */}
      {hashes && (
        <>
          <HashDisplay hashes={hashes} />
          <SigningSection signing={signingFlow} />
        </>
      )}
    </>
  );
}
